<template>
  <div>
    <div id="overlay" v-if="fetchingData">
      <div class="spinner"></div>
    </div>

    <h3>Select Facility</h3>
    <label>
      Select the Facility at which you wish to renew the Operations and Maintanence Permit.
    </label>
    <div class="list-group">
      <router-link
        v-for="facility in facilities"
        v-bind:key="facility.id"
        class="list-group-item list-group-item-action"
        :to="{name: 'OpAndMainRenewal', params: {facilityId: facility.id}}">
        {{facility.name}} -
        {{facility.address.streetNumber}}
        {{facility.address.streetDirection}}
        {{facility.address.streetName}}
        {{facility.address.streetType}}
        {{facility.address.suffixDir}}
      </router-link>
    </div>

  </div>
</template>

<script>
import { getOMFacilities } from '@/js/FormFunctions';

export default {
  name: 'FacilitySelect',
  data() {
    return {
      fetchingData: false,
      facilities: [],
    };
  },
  mounted() {
    const vm = this;
    this.fetchingData = true;
    getOMFacilities()
      .then((facilities) => {
        vm.fetchingData = false;
        vm.facilities = facilities;
      })
      .catch(() => {
        vm.fetchingData = false;
      });
  },
};
</script>
